export enum SnackbarBackground {
  YELLOW = '#FFD966',
  RED = '#CD4E5F',
  GREEN = '#2AAB3F',
  ORANGE = '#EB8E30',
}

export enum Colors {
  YELLOW = 'yellow',
  RED = 'red',
  GREEN = 'green',
  ORANGE = 'orange',
}
